<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Acente Muhasebe </h3>
                <a :href="basePath+'/reports/97'"><i class="la la-chart-line mr-2 text-color-7"></i>Acente Ödeme Raporu</a>
              </div>
            </div>
            <div class="form-content pb-2">
              <p class="font-size-14" v-if="agencyOutLines != null">{{ agencyOutLines.length }} listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th>Acente Adı</th>
                    <th>Toplam Harcama</th>
                    <th>Toplam Ödeme</th>
                    <th>Borç</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="outline in agencyOutLines">
                    <th><a :href="basePath+'/agencies/'+outline.agency.id">#{{outline.agency.id}}</a></th>
                    <th>{{ outline.agency.name }}</th>
                    <th>{{ outline.spendTotal | toCurrency}}</th>
                    <th>{{ outline.paidTotal | toCurrency}}</th>
                    <th :style="getDebtColor(outline.spendTotal - outline.paidTotal)">{{ (outline.spendTotal-outline.paidTotal) | toCurrency}}</th>
                    <td>
                      <div class="table-content">
                        <button @click="showPaymentListModal(outline)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                          <i class="la la-info"></i>
                        </button>
                        <button @click="createAgencyPayment(outline)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                          <i class="la la-plus"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgencyOutlineList",
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList;
      }
    },
    agencyOutLines:{
      get(){
        return this.$store.getters.getAgencyPaymentOutlines;
      }
    }
  },
  methods:{
    showPaymentListModal(outline){
      this.$store.commit("setSelectedAgencyOutline",outline);
      this.$store.dispatch("loadAgencyPaymentByAgencyId", {id:outline.agency.id}).then(()=>{
        $("#agencyPaymentListModal").modal("show");
      })
    },
    createAgencyPayment(outline){
      this.$store.commit("setSelectedAgencyPayment",{});
      this.$store.commit("setUpdateProcess",false);
      this.$store.commit("setSelectedAgencyOutline",outline);
      $("#createAgencyPaymentModal").modal("show");
    },
    getDebtColor(amount) {
      if (amount <= 0){
        return "color: #0da33e"
      }else if(amount < 5000){
        return "color: #9e9d24"
      }else{
        return "color: #880e4f";
      }
    }
  },

}
</script>

<style scoped>

</style>